import { r as Ye, g as Ze, c as je, t as er } from "../../___vite-browser-external_commonjs-proxy-820355ce.js";
import { c as rr } from "../../_commonjsHelpers-c5d32002.js";
var ge = typeof Map == "function" && Map.prototype, ae = Object.getOwnPropertyDescriptor && ge ? Object.getOwnPropertyDescriptor(Map.prototype, "size") : null, ee = ge && ae && typeof ae.get == "function" ? ae.get : null, xe = ge && Map.prototype.forEach, Se = typeof Set == "function" && Set.prototype, ie = Object.getOwnPropertyDescriptor && Se ? Object.getOwnPropertyDescriptor(Set.prototype, "size") : null, re = Se && ie && typeof ie.get == "function" ? ie.get : null, $e = Se && Set.prototype.forEach, tr = typeof WeakMap == "function" && WeakMap.prototype, k = tr ? WeakMap.prototype.has : null, nr = typeof WeakSet == "function" && WeakSet.prototype, V = nr ? WeakSet.prototype.has : null, ar = typeof WeakRef == "function" && WeakRef.prototype, De = ar ? WeakRef.prototype.deref : null, ir = Boolean.prototype.valueOf, or = Object.prototype.toString, lr = Function.prototype.toString, fr = String.prototype.match, we = String.prototype.slice, F = String.prototype.replace, ur = String.prototype.toUpperCase, Ae = String.prototype.toLowerCase, We = RegExp.prototype.test, Ie = Array.prototype.concat, x = Array.prototype.join, cr = Array.prototype.slice, Ne = Math.floor, se = typeof BigInt == "function" ? BigInt.prototype.valueOf : null, oe = Object.getOwnPropertySymbols, ye = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Symbol.prototype.toString : null, K = typeof Symbol == "function" && typeof Symbol.iterator == "object", g = typeof Symbol == "function" && Symbol.toStringTag && (typeof Symbol.toStringTag === K || "symbol") ? Symbol.toStringTag : null, _e = Object.prototype.propertyIsEnumerable, Te = (typeof Reflect == "function" ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype ? function(r) {
  return r.__proto__;
} : null);
function Me(r, e) {
  if (r === 1 / 0 || r === -1 / 0 || r !== r || r && r > -1e3 && r < 1e3 || We.call(/e/, e))
    return e;
  var t = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
  if (typeof r == "number") {
    var n = r < 0 ? -Ne(-r) : Ne(r);
    if (n !== r) {
      var i = String(n), a = we.call(e, i.length + 1);
      return F.call(i, t, "$&_") + "." + F.call(F.call(a, /([0-9]{3})/g, "$&_"), /_$/, "");
    }
  }
  return F.call(e, t, "$&_");
}
var de = Ye, Fe = de.custom, Ce = Be(Fe) ? Fe : null, pr = function r(e, t, n, i) {
  var a = t || {};
  if (M(a, "quoteStyle") && a.quoteStyle !== "single" && a.quoteStyle !== "double")
    throw new TypeError('option "quoteStyle" must be "single" or "double"');
  if (M(a, "maxStringLength") && (typeof a.maxStringLength == "number" ? a.maxStringLength < 0 && a.maxStringLength !== 1 / 0 : a.maxStringLength !== null))
    throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
  var o = M(a, "customInspect") ? a.customInspect : !0;
  if (typeof o != "boolean" && o !== "symbol")
    throw new TypeError("option \"customInspect\", if provided, must be `true`, `false`, or `'symbol'`");
  if (M(a, "indent") && a.indent !== null && a.indent !== "	" && !(parseInt(a.indent, 10) === a.indent && a.indent > 0))
    throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
  if (M(a, "numericSeparator") && typeof a.numericSeparator != "boolean")
    throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
  var p = a.numericSeparator;
  if (typeof e > "u")
    return "undefined";
  if (e === null)
    return "null";
  if (typeof e == "boolean")
    return e ? "true" : "false";
  if (typeof e == "string")
    return ze(e, a);
  if (typeof e == "number") {
    if (e === 0)
      return 1 / 0 / e > 0 ? "0" : "-0";
    var l = String(e);
    return p ? Me(e, l) : l;
  }
  if (typeof e == "bigint") {
    var c = String(e) + "n";
    return p ? Me(e, c) : c;
  }
  var u = typeof a.depth > "u" ? 5 : a.depth;
  if (typeof n > "u" && (n = 0), n >= u && u > 0 && typeof e == "object")
    return ve(e) ? "[Array]" : "[Object]";
  var y = Nr(a, n);
  if (typeof i > "u")
    i = [];
  else if (He(i, e) >= 0)
    return "[Circular]";
  function f(O, N, T) {
    if (N && (i = cr.call(i), i.push(N)), T) {
      var Q = {
        depth: a.depth
      };
      return M(a, "quoteStyle") && (Q.quoteStyle = a.quoteStyle), r(O, Q, n + 1, i);
    }
    return r(O, a, n + 1, i);
  }
  if (typeof e == "function" && !Re(e)) {
    var v = wr(e), m = X(e, f);
    return "[Function" + (v ? ": " + v : " (anonymous)") + "]" + (m.length > 0 ? " { " + x.call(m, ", ") + " }" : "");
  }
  if (Be(e)) {
    var w = K ? F.call(String(e), /^(Symbol\(.*\))_[^)]*$/, "$1") : ye.call(e);
    return typeof e == "object" && !K ? q(w) : w;
  }
  if (Dr(e)) {
    for (var S = "<" + Ae.call(String(e.nodeName)), $ = e.attributes || [], D = 0; D < $.length; D++)
      S += " " + $[D].name + "=" + Ke(sr($[D].value), "double", a);
    return S += ">", e.childNodes && e.childNodes.length && (S += "..."), S += "</" + Ae.call(String(e.nodeName)) + ">", S;
  }
  if (ve(e)) {
    if (e.length === 0)
      return "[]";
    var s = X(e, f);
    return y && !Ir(s) ? "[" + me(s, y) + "]" : "[ " + x.call(s, ", ") + " ]";
  }
  if (dr(e)) {
    var A = X(e, f);
    return !("cause" in Error.prototype) && "cause" in e && !_e.call(e, "cause") ? "{ [" + String(e) + "] " + x.call(Ie.call("[cause]: " + f(e.cause), A), ", ") + " }" : A.length === 0 ? "[" + String(e) + "]" : "{ [" + String(e) + "] " + x.call(A, ", ") + " }";
  }
  if (typeof e == "object" && o) {
    if (Ce && typeof e[Ce] == "function" && de)
      return de(e, { depth: u - n });
    if (o !== "symbol" && typeof e.inspect == "function")
      return e.inspect();
  }
  if (Or(e)) {
    var R = [];
    return xe && xe.call(e, function(O, N) {
      R.push(f(N, e, !0) + " => " + f(O, e));
    }), Pe("Map", ee.call(e), R, y);
  }
  if (xr(e)) {
    var z = [];
    return $e && $e.call(e, function(O) {
      z.push(f(O, e));
    }), Pe("Set", re.call(e), z, y);
  }
  if (br(e))
    return le("WeakMap");
  if ($r(e))
    return le("WeakSet");
  if (Er(e))
    return le("WeakRef");
  if (mr(e))
    return q(f(Number(e)));
  if (gr(e))
    return q(f(se.call(e)));
  if (hr(e))
    return q(ir.call(e));
  if (vr(e))
    return q(f(String(e)));
  if (typeof window < "u" && e === window)
    return "{ [object Window] }";
  if (e === rr)
    return "{ [object globalThis] }";
  if (!yr(e) && !Re(e)) {
    var W = X(e, f), U = Te ? Te(e) === Object.prototype : e instanceof Object || e.constructor === Object, P = e instanceof Object ? "" : "null prototype", I = !U && g && Object(e) === e && g in e ? we.call(C(e), 8, -1) : P ? "Object" : "", J = U || typeof e.constructor != "function" ? "" : e.constructor.name ? e.constructor.name + " " : "", _ = J + (I || P ? "[" + x.call(Ie.call([], I || [], P || []), ": ") + "] " : "");
    return W.length === 0 ? _ + "{}" : y ? _ + "{" + me(W, y) + "}" : _ + "{ " + x.call(W, ", ") + " }";
  }
  return String(e);
};
function Ke(r, e, t) {
  var n = (t.quoteStyle || e) === "double" ? '"' : "'";
  return n + r + n;
}
function sr(r) {
  return F.call(String(r), /"/g, "&quot;");
}
function ve(r) {
  return C(r) === "[object Array]" && (!g || !(typeof r == "object" && g in r));
}
function yr(r) {
  return C(r) === "[object Date]" && (!g || !(typeof r == "object" && g in r));
}
function Re(r) {
  return C(r) === "[object RegExp]" && (!g || !(typeof r == "object" && g in r));
}
function dr(r) {
  return C(r) === "[object Error]" && (!g || !(typeof r == "object" && g in r));
}
function vr(r) {
  return C(r) === "[object String]" && (!g || !(typeof r == "object" && g in r));
}
function mr(r) {
  return C(r) === "[object Number]" && (!g || !(typeof r == "object" && g in r));
}
function hr(r) {
  return C(r) === "[object Boolean]" && (!g || !(typeof r == "object" && g in r));
}
function Be(r) {
  if (K)
    return r && typeof r == "object" && r instanceof Symbol;
  if (typeof r == "symbol")
    return !0;
  if (!r || typeof r != "object" || !ye)
    return !1;
  try {
    return ye.call(r), !0;
  } catch {
  }
  return !1;
}
function gr(r) {
  if (!r || typeof r != "object" || !se)
    return !1;
  try {
    return se.call(r), !0;
  } catch {
  }
  return !1;
}
var Sr = Object.prototype.hasOwnProperty || function(r) {
  return r in this;
};
function M(r, e) {
  return Sr.call(r, e);
}
function C(r) {
  return or.call(r);
}
function wr(r) {
  if (r.name)
    return r.name;
  var e = fr.call(lr.call(r), /^function\s*([\w$]+)/);
  return e ? e[1] : null;
}
function He(r, e) {
  if (r.indexOf)
    return r.indexOf(e);
  for (var t = 0, n = r.length; t < n; t++)
    if (r[t] === e)
      return t;
  return -1;
}
function Or(r) {
  if (!ee || !r || typeof r != "object")
    return !1;
  try {
    ee.call(r);
    try {
      re.call(r);
    } catch {
      return !0;
    }
    return r instanceof Map;
  } catch {
  }
  return !1;
}
function br(r) {
  if (!k || !r || typeof r != "object")
    return !1;
  try {
    k.call(r, k);
    try {
      V.call(r, V);
    } catch {
      return !0;
    }
    return r instanceof WeakMap;
  } catch {
  }
  return !1;
}
function Er(r) {
  if (!De || !r || typeof r != "object")
    return !1;
  try {
    return De.call(r), !0;
  } catch {
  }
  return !1;
}
function xr(r) {
  if (!re || !r || typeof r != "object")
    return !1;
  try {
    re.call(r);
    try {
      ee.call(r);
    } catch {
      return !0;
    }
    return r instanceof Set;
  } catch {
  }
  return !1;
}
function $r(r) {
  if (!V || !r || typeof r != "object")
    return !1;
  try {
    V.call(r, V);
    try {
      k.call(r, k);
    } catch {
      return !0;
    }
    return r instanceof WeakSet;
  } catch {
  }
  return !1;
}
function Dr(r) {
  return !r || typeof r != "object" ? !1 : typeof HTMLElement < "u" && r instanceof HTMLElement ? !0 : typeof r.nodeName == "string" && typeof r.getAttribute == "function";
}
function ze(r, e) {
  if (r.length > e.maxStringLength) {
    var t = r.length - e.maxStringLength, n = "... " + t + " more character" + (t > 1 ? "s" : "");
    return ze(we.call(r, 0, e.maxStringLength), e) + n;
  }
  var i = F.call(F.call(r, /(['\\])/g, "\\$1"), /[\x00-\x1f]/g, Ar);
  return Ke(i, "single", e);
}
function Ar(r) {
  var e = r.charCodeAt(0), t = {
    8: "b",
    9: "t",
    10: "n",
    12: "f",
    13: "r"
  }[e];
  return t ? "\\" + t : "\\x" + (e < 16 ? "0" : "") + ur.call(e.toString(16));
}
function q(r) {
  return "Object(" + r + ")";
}
function le(r) {
  return r + " { ? }";
}
function Pe(r, e, t, n) {
  var i = n ? me(t, n) : x.call(t, ", ");
  return r + " (" + e + ") {" + i + "}";
}
function Ir(r) {
  for (var e = 0; e < r.length; e++)
    if (He(r[e], `
`) >= 0)
      return !1;
  return !0;
}
function Nr(r, e) {
  var t;
  if (r.indent === "	")
    t = "	";
  else if (typeof r.indent == "number" && r.indent > 0)
    t = x.call(Array(r.indent + 1), " ");
  else
    return null;
  return {
    base: t,
    prev: x.call(Array(e + 1), t)
  };
}
function me(r, e) {
  if (r.length === 0)
    return "";
  var t = `
` + e.prev + e.base;
  return t + x.call(r, "," + t) + `
` + e.prev;
}
function X(r, e) {
  var t = ve(r), n = [];
  if (t) {
    n.length = r.length;
    for (var i = 0; i < r.length; i++)
      n[i] = M(r, i) ? e(r[i], r) : "";
  }
  var a = typeof oe == "function" ? oe(r) : [], o;
  if (K) {
    o = {};
    for (var p = 0; p < a.length; p++)
      o["$" + a[p]] = a[p];
  }
  for (var l in r)
    M(r, l) && (t && String(Number(l)) === l && l < r.length || K && o["$" + l] instanceof Symbol || (We.call(/[^\w$]/, l) ? n.push(e(l, r) + ": " + e(r[l], r)) : n.push(l + ": " + e(r[l], r))));
  if (typeof oe == "function")
    for (var c = 0; c < a.length; c++)
      _e.call(r, a[c]) && n.push("[" + e(a[c]) + "]: " + e(r[a[c]], r));
  return n;
}
var Qe = Ze, H = je, Tr = pr, Mr = er, Y = Qe("%WeakMap%", !0), Z = Qe("%Map%", !0), Fr = H("WeakMap.prototype.get", !0), Cr = H("WeakMap.prototype.set", !0), Rr = H("WeakMap.prototype.has", !0), Pr = H("Map.prototype.get", !0), Lr = H("Map.prototype.set", !0), Wr = H("Map.prototype.has", !0), Oe = function(r, e) {
  for (var t = r, n; (n = t.next) !== null; t = n)
    if (n.key === e)
      return t.next = n.next, n.next = /** @type {NonNullable<typeof list.next>} */
      r.next, r.next = n, n;
}, _r = function(r, e) {
  var t = Oe(r, e);
  return t && t.value;
}, Kr = function(r, e, t) {
  var n = Oe(r, e);
  n ? n.value = t : r.next = /** @type {import('.').ListNode<typeof value>} */
  {
    // eslint-disable-line no-param-reassign, no-extra-parens
    key: e,
    next: r.next,
    value: t
  };
}, Br = function(r, e) {
  return !!Oe(r, e);
}, Hr = function() {
  var e, t, n, i = {
    assert: function(a) {
      if (!i.has(a))
        throw new Mr("Side channel does not contain " + Tr(a));
    },
    get: function(a) {
      if (Y && a && (typeof a == "object" || typeof a == "function")) {
        if (e)
          return Fr(e, a);
      } else if (Z) {
        if (t)
          return Pr(t, a);
      } else if (n)
        return _r(n, a);
    },
    has: function(a) {
      if (Y && a && (typeof a == "object" || typeof a == "function")) {
        if (e)
          return Rr(e, a);
      } else if (Z) {
        if (t)
          return Wr(t, a);
      } else if (n)
        return Br(n, a);
      return !1;
    },
    set: function(a, o) {
      Y && a && (typeof a == "object" || typeof a == "function") ? (e || (e = new Y()), Cr(e, a, o)) : Z ? (t || (t = new Z()), Lr(t, a, o)) : (n || (n = { key: {}, next: null }), Kr(n, a, o));
    }
  };
  return i;
}, zr = String.prototype.replace, Qr = /%20/g, fe = {
  RFC1738: "RFC1738",
  RFC3986: "RFC3986"
}, be = {
  default: fe.RFC3986,
  formatters: {
    RFC1738: function(r) {
      return zr.call(r, Qr, "+");
    },
    RFC3986: function(r) {
      return String(r);
    }
  },
  RFC1738: fe.RFC1738,
  RFC3986: fe.RFC3986
}, qr = be, ue = Object.prototype.hasOwnProperty, L = Array.isArray, b = function() {
  for (var r = [], e = 0; e < 256; ++e)
    r.push("%" + ((e < 16 ? "0" : "") + e.toString(16)).toUpperCase());
  return r;
}(), kr = function(e) {
  for (; e.length > 1; ) {
    var t = e.pop(), n = t.obj[t.prop];
    if (L(n)) {
      for (var i = [], a = 0; a < n.length; ++a)
        typeof n[a] < "u" && i.push(n[a]);
      t.obj[t.prop] = i;
    }
  }
}, qe = function(e, t) {
  for (var n = t && t.plainObjects ? /* @__PURE__ */ Object.create(null) : {}, i = 0; i < e.length; ++i)
    typeof e[i] < "u" && (n[i] = e[i]);
  return n;
}, Vr = function r(e, t, n) {
  if (!t)
    return e;
  if (typeof t != "object") {
    if (L(e))
      e.push(t);
    else if (e && typeof e == "object")
      (n && (n.plainObjects || n.allowPrototypes) || !ue.call(Object.prototype, t)) && (e[t] = !0);
    else
      return [e, t];
    return e;
  }
  if (!e || typeof e != "object")
    return [e].concat(t);
  var i = e;
  return L(e) && !L(t) && (i = qe(e, n)), L(e) && L(t) ? (t.forEach(function(a, o) {
    if (ue.call(e, o)) {
      var p = e[o];
      p && typeof p == "object" && a && typeof a == "object" ? e[o] = r(p, a, n) : e.push(a);
    } else
      e[o] = a;
  }), e) : Object.keys(t).reduce(function(a, o) {
    var p = t[o];
    return ue.call(a, o) ? a[o] = r(a[o], p, n) : a[o] = p, a;
  }, i);
}, Gr = function(e, t) {
  return Object.keys(t).reduce(function(n, i) {
    return n[i] = t[i], n;
  }, e);
}, Ur = function(r, e, t) {
  var n = r.replace(/\+/g, " ");
  if (t === "iso-8859-1")
    return n.replace(/%[0-9a-f]{2}/gi, unescape);
  try {
    return decodeURIComponent(n);
  } catch {
    return n;
  }
}, ce = 1024, Jr = function(e, t, n, i, a) {
  if (e.length === 0)
    return e;
  var o = e;
  if (typeof e == "symbol" ? o = Symbol.prototype.toString.call(e) : typeof e != "string" && (o = String(e)), n === "iso-8859-1")
    return escape(o).replace(/%u[0-9a-f]{4}/gi, function(v) {
      return "%26%23" + parseInt(v.slice(2), 16) + "%3B";
    });
  for (var p = "", l = 0; l < o.length; l += ce) {
    for (var c = o.length >= ce ? o.slice(l, l + ce) : o, u = [], y = 0; y < c.length; ++y) {
      var f = c.charCodeAt(y);
      if (f === 45 || f === 46 || f === 95 || f === 126 || f >= 48 && f <= 57 || f >= 65 && f <= 90 || f >= 97 && f <= 122 || a === qr.RFC1738 && (f === 40 || f === 41)) {
        u[u.length] = c.charAt(y);
        continue;
      }
      if (f < 128) {
        u[u.length] = b[f];
        continue;
      }
      if (f < 2048) {
        u[u.length] = b[192 | f >> 6] + b[128 | f & 63];
        continue;
      }
      if (f < 55296 || f >= 57344) {
        u[u.length] = b[224 | f >> 12] + b[128 | f >> 6 & 63] + b[128 | f & 63];
        continue;
      }
      y += 1, f = 65536 + ((f & 1023) << 10 | c.charCodeAt(y) & 1023), u[u.length] = b[240 | f >> 18] + b[128 | f >> 12 & 63] + b[128 | f >> 6 & 63] + b[128 | f & 63];
    }
    p += u.join("");
  }
  return p;
}, Xr = function(e) {
  for (var t = [{ obj: { o: e }, prop: "o" }], n = [], i = 0; i < t.length; ++i)
    for (var a = t[i], o = a.obj[a.prop], p = Object.keys(o), l = 0; l < p.length; ++l) {
      var c = p[l], u = o[c];
      typeof u == "object" && u !== null && n.indexOf(u) === -1 && (t.push({ obj: o, prop: c }), n.push(u));
    }
  return kr(t), e;
}, Yr = function(e) {
  return Object.prototype.toString.call(e) === "[object RegExp]";
}, Zr = function(e) {
  return !e || typeof e != "object" ? !1 : !!(e.constructor && e.constructor.isBuffer && e.constructor.isBuffer(e));
}, jr = function(e, t) {
  return [].concat(e, t);
}, et = function(e, t) {
  if (L(e)) {
    for (var n = [], i = 0; i < e.length; i += 1)
      n.push(t(e[i]));
    return n;
  }
  return t(e);
}, ke = {
  arrayToObject: qe,
  assign: Gr,
  combine: jr,
  compact: Xr,
  decode: Ur,
  encode: Jr,
  isBuffer: Zr,
  isRegExp: Yr,
  maybeMap: et,
  merge: Vr
}, Ve = Hr, j = ke, G = be, rt = Object.prototype.hasOwnProperty, Ge = {
  brackets: function(e) {
    return e + "[]";
  },
  comma: "comma",
  indices: function(e, t) {
    return e + "[" + t + "]";
  },
  repeat: function(e) {
    return e;
  }
}, E = Array.isArray, tt = Array.prototype.push, Ue = function(r, e) {
  tt.apply(r, E(e) ? e : [e]);
}, nt = Date.prototype.toISOString, Le = G.default, h = {
  addQueryPrefix: !1,
  allowDots: !1,
  allowEmptyArrays: !1,
  arrayFormat: "indices",
  charset: "utf-8",
  charsetSentinel: !1,
  delimiter: "&",
  encode: !0,
  encodeDotInKeys: !1,
  encoder: j.encode,
  encodeValuesOnly: !1,
  format: Le,
  formatter: G.formatters[Le],
  // deprecated
  indices: !1,
  serializeDate: function(e) {
    return nt.call(e);
  },
  skipNulls: !1,
  strictNullHandling: !1
}, at = function(e) {
  return typeof e == "string" || typeof e == "number" || typeof e == "boolean" || typeof e == "symbol" || typeof e == "bigint";
}, pe = {}, it = function r(e, t, n, i, a, o, p, l, c, u, y, f, v, m, w, S, $, D) {
  for (var s = e, A = D, R = 0, z = !1; (A = A.get(pe)) !== void 0 && !z; ) {
    var W = A.get(e);
    if (R += 1, typeof W < "u") {
      if (W === R)
        throw new RangeError("Cyclic object value");
      z = !0;
    }
    typeof A.get(pe) > "u" && (R = 0);
  }
  if (typeof u == "function" ? s = u(t, s) : s instanceof Date ? s = v(s) : n === "comma" && E(s) && (s = j.maybeMap(s, function(ne) {
    return ne instanceof Date ? v(ne) : ne;
  })), s === null) {
    if (o)
      return c && !S ? c(t, h.encoder, $, "key", m) : t;
    s = "";
  }
  if (at(s) || j.isBuffer(s)) {
    if (c) {
      var U = S ? t : c(t, h.encoder, $, "key", m);
      return [w(U) + "=" + w(c(s, h.encoder, $, "value", m))];
    }
    return [w(t) + "=" + w(String(s))];
  }
  var P = [];
  if (typeof s > "u")
    return P;
  var I;
  if (n === "comma" && E(s))
    S && c && (s = j.maybeMap(s, c)), I = [{ value: s.length > 0 ? s.join(",") || null : void 0 }];
  else if (E(u))
    I = u;
  else {
    var J = Object.keys(s);
    I = y ? J.sort(y) : J;
  }
  var _ = l ? t.replace(/\./g, "%2E") : t, O = i && E(s) && s.length === 1 ? _ + "[]" : _;
  if (a && E(s) && s.length === 0)
    return O + "[]";
  for (var N = 0; N < I.length; ++N) {
    var T = I[N], Q = typeof T == "object" && typeof T.value < "u" ? T.value : s[T];
    if (!(p && Q === null)) {
      var te = f && l ? T.replace(/\./g, "%2E") : T, Xe = E(s) ? typeof n == "function" ? n(O, te) : O : O + (f ? "." + te : "[" + te + "]");
      D.set(e, R);
      var Ee = Ve();
      Ee.set(pe, D), Ue(P, r(
        Q,
        Xe,
        n,
        i,
        a,
        o,
        p,
        l,
        n === "comma" && S && E(s) ? null : c,
        u,
        y,
        f,
        v,
        m,
        w,
        S,
        $,
        Ee
      ));
    }
  }
  return P;
}, ot = function(e) {
  if (!e)
    return h;
  if (typeof e.allowEmptyArrays < "u" && typeof e.allowEmptyArrays != "boolean")
    throw new TypeError("`allowEmptyArrays` option can only be `true` or `false`, when provided");
  if (typeof e.encodeDotInKeys < "u" && typeof e.encodeDotInKeys != "boolean")
    throw new TypeError("`encodeDotInKeys` option can only be `true` or `false`, when provided");
  if (e.encoder !== null && typeof e.encoder < "u" && typeof e.encoder != "function")
    throw new TypeError("Encoder has to be a function.");
  var t = e.charset || h.charset;
  if (typeof e.charset < "u" && e.charset !== "utf-8" && e.charset !== "iso-8859-1")
    throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
  var n = G.default;
  if (typeof e.format < "u") {
    if (!rt.call(G.formatters, e.format))
      throw new TypeError("Unknown format option provided.");
    n = e.format;
  }
  var i = G.formatters[n], a = h.filter;
  (typeof e.filter == "function" || E(e.filter)) && (a = e.filter);
  var o;
  if (e.arrayFormat in Ge ? o = e.arrayFormat : "indices" in e ? o = e.indices ? "indices" : "repeat" : o = h.arrayFormat, "commaRoundTrip" in e && typeof e.commaRoundTrip != "boolean")
    throw new TypeError("`commaRoundTrip` must be a boolean, or absent");
  var p = typeof e.allowDots > "u" ? e.encodeDotInKeys === !0 ? !0 : h.allowDots : !!e.allowDots;
  return {
    addQueryPrefix: typeof e.addQueryPrefix == "boolean" ? e.addQueryPrefix : h.addQueryPrefix,
    allowDots: p,
    allowEmptyArrays: typeof e.allowEmptyArrays == "boolean" ? !!e.allowEmptyArrays : h.allowEmptyArrays,
    arrayFormat: o,
    charset: t,
    charsetSentinel: typeof e.charsetSentinel == "boolean" ? e.charsetSentinel : h.charsetSentinel,
    commaRoundTrip: e.commaRoundTrip,
    delimiter: typeof e.delimiter > "u" ? h.delimiter : e.delimiter,
    encode: typeof e.encode == "boolean" ? e.encode : h.encode,
    encodeDotInKeys: typeof e.encodeDotInKeys == "boolean" ? e.encodeDotInKeys : h.encodeDotInKeys,
    encoder: typeof e.encoder == "function" ? e.encoder : h.encoder,
    encodeValuesOnly: typeof e.encodeValuesOnly == "boolean" ? e.encodeValuesOnly : h.encodeValuesOnly,
    filter: a,
    format: n,
    formatter: i,
    serializeDate: typeof e.serializeDate == "function" ? e.serializeDate : h.serializeDate,
    skipNulls: typeof e.skipNulls == "boolean" ? e.skipNulls : h.skipNulls,
    sort: typeof e.sort == "function" ? e.sort : null,
    strictNullHandling: typeof e.strictNullHandling == "boolean" ? e.strictNullHandling : h.strictNullHandling
  };
}, lt = function(r, e) {
  var t = r, n = ot(e), i, a;
  typeof n.filter == "function" ? (a = n.filter, t = a("", t)) : E(n.filter) && (a = n.filter, i = a);
  var o = [];
  if (typeof t != "object" || t === null)
    return "";
  var p = Ge[n.arrayFormat], l = p === "comma" && n.commaRoundTrip;
  i || (i = Object.keys(t)), n.sort && i.sort(n.sort);
  for (var c = Ve(), u = 0; u < i.length; ++u) {
    var y = i[u];
    n.skipNulls && t[y] === null || Ue(o, it(
      t[y],
      y,
      p,
      l,
      n.allowEmptyArrays,
      n.strictNullHandling,
      n.skipNulls,
      n.encodeDotInKeys,
      n.encode ? n.encoder : null,
      n.filter,
      n.sort,
      n.allowDots,
      n.serializeDate,
      n.format,
      n.formatter,
      n.encodeValuesOnly,
      n.charset,
      c
    ));
  }
  var f = o.join(n.delimiter), v = n.addQueryPrefix === !0 ? "?" : "";
  return n.charsetSentinel && (n.charset === "iso-8859-1" ? v += "utf8=%26%2310003%3B&" : v += "utf8=%E2%9C%93&"), f.length > 0 ? v + f : "";
}, B = ke, he = Object.prototype.hasOwnProperty, ft = Array.isArray, d = {
  allowDots: !1,
  allowEmptyArrays: !1,
  allowPrototypes: !1,
  allowSparse: !1,
  arrayLimit: 20,
  charset: "utf-8",
  charsetSentinel: !1,
  comma: !1,
  decodeDotInKeys: !1,
  decoder: B.decode,
  delimiter: "&",
  depth: 5,
  duplicates: "combine",
  ignoreQueryPrefix: !1,
  interpretNumericEntities: !1,
  parameterLimit: 1e3,
  parseArrays: !0,
  plainObjects: !1,
  strictNullHandling: !1
}, ut = function(r) {
  return r.replace(/&#(\d+);/g, function(e, t) {
    return String.fromCharCode(parseInt(t, 10));
  });
}, Je = function(r, e) {
  return r && typeof r == "string" && e.comma && r.indexOf(",") > -1 ? r.split(",") : r;
}, ct = "utf8=%26%2310003%3B", pt = "utf8=%E2%9C%93", st = function(e, t) {
  var n = { __proto__: null }, i = t.ignoreQueryPrefix ? e.replace(/^\?/, "") : e, a = t.parameterLimit === 1 / 0 ? void 0 : t.parameterLimit, o = i.split(t.delimiter, a), p = -1, l, c = t.charset;
  if (t.charsetSentinel)
    for (l = 0; l < o.length; ++l)
      o[l].indexOf("utf8=") === 0 && (o[l] === pt ? c = "utf-8" : o[l] === ct && (c = "iso-8859-1"), p = l, l = o.length);
  for (l = 0; l < o.length; ++l)
    if (l !== p) {
      var u = o[l], y = u.indexOf("]="), f = y === -1 ? u.indexOf("=") : y + 1, v, m;
      f === -1 ? (v = t.decoder(u, d.decoder, c, "key"), m = t.strictNullHandling ? null : "") : (v = t.decoder(u.slice(0, f), d.decoder, c, "key"), m = B.maybeMap(
        Je(u.slice(f + 1), t),
        function(S) {
          return t.decoder(S, d.decoder, c, "value");
        }
      )), m && t.interpretNumericEntities && c === "iso-8859-1" && (m = ut(m)), u.indexOf("[]=") > -1 && (m = ft(m) ? [m] : m);
      var w = he.call(n, v);
      w && t.duplicates === "combine" ? n[v] = B.combine(n[v], m) : (!w || t.duplicates === "last") && (n[v] = m);
    }
  return n;
}, yt = function(r, e, t, n) {
  for (var i = n ? e : Je(e, t), a = r.length - 1; a >= 0; --a) {
    var o, p = r[a];
    if (p === "[]" && t.parseArrays)
      o = t.allowEmptyArrays && i === "" ? [] : [].concat(i);
    else {
      o = t.plainObjects ? /* @__PURE__ */ Object.create(null) : {};
      var l = p.charAt(0) === "[" && p.charAt(p.length - 1) === "]" ? p.slice(1, -1) : p, c = t.decodeDotInKeys ? l.replace(/%2E/g, ".") : l, u = parseInt(c, 10);
      !t.parseArrays && c === "" ? o = { 0: i } : !isNaN(u) && p !== c && String(u) === c && u >= 0 && t.parseArrays && u <= t.arrayLimit ? (o = [], o[u] = i) : c !== "__proto__" && (o[c] = i);
    }
    i = o;
  }
  return i;
}, dt = function(e, t, n, i) {
  if (e) {
    var a = n.allowDots ? e.replace(/\.([^.[]+)/g, "[$1]") : e, o = /(\[[^[\]]*])/, p = /(\[[^[\]]*])/g, l = n.depth > 0 && o.exec(a), c = l ? a.slice(0, l.index) : a, u = [];
    if (c) {
      if (!n.plainObjects && he.call(Object.prototype, c) && !n.allowPrototypes)
        return;
      u.push(c);
    }
    for (var y = 0; n.depth > 0 && (l = p.exec(a)) !== null && y < n.depth; ) {
      if (y += 1, !n.plainObjects && he.call(Object.prototype, l[1].slice(1, -1)) && !n.allowPrototypes)
        return;
      u.push(l[1]);
    }
    return l && u.push("[" + a.slice(l.index) + "]"), yt(u, t, n, i);
  }
}, vt = function(e) {
  if (!e)
    return d;
  if (typeof e.allowEmptyArrays < "u" && typeof e.allowEmptyArrays != "boolean")
    throw new TypeError("`allowEmptyArrays` option can only be `true` or `false`, when provided");
  if (typeof e.decodeDotInKeys < "u" && typeof e.decodeDotInKeys != "boolean")
    throw new TypeError("`decodeDotInKeys` option can only be `true` or `false`, when provided");
  if (e.decoder !== null && typeof e.decoder < "u" && typeof e.decoder != "function")
    throw new TypeError("Decoder has to be a function.");
  if (typeof e.charset < "u" && e.charset !== "utf-8" && e.charset !== "iso-8859-1")
    throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
  var t = typeof e.charset > "u" ? d.charset : e.charset, n = typeof e.duplicates > "u" ? d.duplicates : e.duplicates;
  if (n !== "combine" && n !== "first" && n !== "last")
    throw new TypeError("The duplicates option must be either combine, first, or last");
  var i = typeof e.allowDots > "u" ? e.decodeDotInKeys === !0 ? !0 : d.allowDots : !!e.allowDots;
  return {
    allowDots: i,
    allowEmptyArrays: typeof e.allowEmptyArrays == "boolean" ? !!e.allowEmptyArrays : d.allowEmptyArrays,
    allowPrototypes: typeof e.allowPrototypes == "boolean" ? e.allowPrototypes : d.allowPrototypes,
    allowSparse: typeof e.allowSparse == "boolean" ? e.allowSparse : d.allowSparse,
    arrayLimit: typeof e.arrayLimit == "number" ? e.arrayLimit : d.arrayLimit,
    charset: t,
    charsetSentinel: typeof e.charsetSentinel == "boolean" ? e.charsetSentinel : d.charsetSentinel,
    comma: typeof e.comma == "boolean" ? e.comma : d.comma,
    decodeDotInKeys: typeof e.decodeDotInKeys == "boolean" ? e.decodeDotInKeys : d.decodeDotInKeys,
    decoder: typeof e.decoder == "function" ? e.decoder : d.decoder,
    delimiter: typeof e.delimiter == "string" || B.isRegExp(e.delimiter) ? e.delimiter : d.delimiter,
    // eslint-disable-next-line no-implicit-coercion, no-extra-parens
    depth: typeof e.depth == "number" || e.depth === !1 ? +e.depth : d.depth,
    duplicates: n,
    ignoreQueryPrefix: e.ignoreQueryPrefix === !0,
    interpretNumericEntities: typeof e.interpretNumericEntities == "boolean" ? e.interpretNumericEntities : d.interpretNumericEntities,
    parameterLimit: typeof e.parameterLimit == "number" ? e.parameterLimit : d.parameterLimit,
    parseArrays: e.parseArrays !== !1,
    plainObjects: typeof e.plainObjects == "boolean" ? e.plainObjects : d.plainObjects,
    strictNullHandling: typeof e.strictNullHandling == "boolean" ? e.strictNullHandling : d.strictNullHandling
  };
}, mt = function(r, e) {
  var t = vt(e);
  if (r === "" || r === null || typeof r > "u")
    return t.plainObjects ? /* @__PURE__ */ Object.create(null) : {};
  for (var n = typeof r == "string" ? st(r, t) : r, i = t.plainObjects ? /* @__PURE__ */ Object.create(null) : {}, a = Object.keys(n), o = 0; o < a.length; ++o) {
    var p = a[o], l = dt(p, n[p], t, typeof r == "string");
    i = B.merge(i, l, t);
  }
  return t.allowSparse === !0 ? i : B.compact(i);
}, ht = lt, gt = mt, St = be, wt = {
  formats: St,
  parse: gt,
  stringify: ht
};
const Et = async ({
  query: r,
  accessToken: e,
  sessionToken: t
}) => await (await fetch(
  `https://api.mapbox.com/search/searchbox/v1/suggest?${wt.stringify({
    access_token: e,
    language: "en",
    q: r,
    session_token: t,
    types: "country,city,region"
  })}`
)).json();
export {
  Et as getLocationSuggestions
};
//# sourceMappingURL=LocationPicker.api.es.js.map
